module.exports = __webpack_public_path__ + "img/body-1.eba60a1e.png";